<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useUserStore } from '@/stores'
import { useI18n } from '@/composables/useI18n'
import { texts } from '@/config/brands'

const props = withDefaults(defineProps<{
  // 版位是否含订阅商品(已订阅用户不展示订阅卡,应视为无订阅商品)
  hasSubscribe: boolean
  // 版位是否含 coin 充值商品
  hasTopup: boolean
  // 列表场景的序号前缀(如订阅中心 Tips 的 "3. ")
  prefix?: string
}>(), {
  prefix: '',
})

const userStore = useUserStore()
const { t } = useI18n()
const router = useRouter()

// 广告归因用户(landingPageId 有值,账号级)不展示;纯充值版位不展示
const visible = computed(() => props.hasSubscribe && !userStore.$state.landingPageId)

// 品牌客服邮箱,未配置的品牌不展示联系句
const contactEmail = texts?.contactEmail || ''
const userAgreementUrl = import.meta.env.VITE_USER_AGREEMENT_URL || ''
const privacyPolicyUrl = import.meta.env.VITE_PRIVACY_POLICY_URL || ''

// 跳转设置页;失败时静默,用户停留在当前页面
function goSetting() {
  try {
    router.push('/setting')?.catch?.(() => {})
  }
  catch {}
}
</script>

<template>
  <div v-if="visible" class="auto-renewal-notice">
    <p>
      {{ prefix }}<i18n path="AutoRenewalNotice" tag="span">
        <template #excludeCoins>
          <span v-if="hasTopup">{{ t('AutoRenewalNoticeExcludeCoins') }}</span>
        </template>
        <template #cancelSub>
          <a class="underline" @click.stop="goSetting">{{ t('AutoRenewalNoticeCancelSub') }}</a>
        </template>
      </i18n><i18n v-if="contactEmail" path="AutoRenewalNoticeContact" tag="span">
        <template #email>
          <span>{{ contactEmail }}</span>
        </template>
      </i18n><i18n path="AutoRenewalNoticeDeadline" tag="span">
        <template #deadlineBold>
          <strong>{{ t('AutoRenewalNoticeDeadlineBold') }}</strong>
        </template>
      </i18n>
    </p>
    <p v-if="userAgreementUrl || privacyPolicyUrl" class="mt-4px">
      <a v-if="userAgreementUrl" :href="userAgreementUrl" class="font-bold underline" @click.stop>{{ t('TermsOfUse') }}</a>
      <template v-if="userAgreementUrl && privacyPolicyUrl">
        ·
      </template>
      <a v-if="privacyPolicyUrl" :href="privacyPolicyUrl" class="font-bold underline" @click.stop>{{ t('PrivacyPolicy') }}</a>
    </p>
  </div>
</template>
